import { toast, ToastBar, Toaster } from "react-hot-toast";

export default function DismissableToast() {
  return (
    <div>
      <Toaster
        reverseOrder={false}
        position="top-right"
        toastOptions={{
          duration: 5000,
          className:
            "border-r pt-8 rounded-2xl text-sm px-2 bg-white text-black",
          success: {
            className: "border-l text-sm border-green",
          },
          error: {
            className: "border-l text-sm border-red",
          },
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {icon}
                {message}
                {t.type !== "loading" && (
                  <button  onClick={() => toast.dismiss(t.id)}>
                    <svg
                     
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="w-5 h-5"
                    >
                      <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                    </svg>
                  </button>
                )}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
    </div>
  );
}
